import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import type { SectionProps } from '@/components/sitemap/Section';
import { Section } from '@/components/sitemap/Section';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/sitemap';
import { font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  ${font('alt', { fontSize: '3.1rem', fontWeight: 400, lineHeight: '3.6rem' })};
  text-align: center;
  margin-bottom: 32px;
  margin-top: 32px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('alt', {
          fontSize: '5.6rem',
          fontWeight: 400,
          lineHeight: '7rem',
        })};
        margin-top: 100px;
        margin-bottom: 80px;
    `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & a:hover {
    text-decoration: none;
    color: ${themedColor('primary')};
    text-shadow:
      -0.06ex 0 0 currentColor,
      0.06ex 0 0 currentColor;
  }

  @supports (-webkit-text-stroke-width: 0.04ex) {
    & a:hover {
      text-shadow:
        -0.03ex 0 0 currentColor,
        0.03ex 0 0 currentColor;
      -webkit-text-stroke-width: 0.04ex;
    }
  }

  ${MEDIA_QUERIES.tabletAndDesktop`
        max-width: 120rem;
        margin: 0 auto;
    `}
`;

interface SitemapPageTemplateProps {
  config: Config;
}

export const SitemapPageTemplate: React.FC<SitemapPageTemplateProps> = ({ config }) => {
  useShowHeaderCtaOnScroll(true);
  return (
    <Layout pt={[70, 60, 120]} headerActions={config.layout.headerActions}>
      <SEO {...config.seo} />
      <Title>Sitemap</Title>
      <Container>
        {config.section.map((section: SectionProps) => (
          <Section key={section.title} title={section.title} subsections={section.subsections} href={section.href} />
        ))}
      </Container>
    </Layout>
  );
};
